/**
 * The photo intake's own failure: the chosen file could not be turned into
 * an image to read (the browser cannot decode it, or has no canvas to
 * redraw it on). Taking a clearer photo is the fix, so the copy maps it to
 * invalid_input (photoIntakeKeyOf in errorCopy.ts).
 *
 * Kept apart from photoIntakeApi.ts, with no imports, so the error mapping
 * never loads the transport: tests that stand in for the transport still
 * get the real class.
 */
export class PhotoUnreadableError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'PhotoUnreadableError';
  }
}
